module.exports = __webpack_public_path__ + "img/ex_tips.35076726.png";